import { jsx } from "react/jsx-runtime";
import { ApexFields } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockApexFields = ({
  attrs,
  index,
  innerBlocks = []
}) => /* @__PURE__ */ jsx(ApexFields, { ...attrs, children: generateBlockList({
  blocks: innerBlocks
}) }, index);
BlockApexFields.propTypes = {
  index: PropTypes.number,
  attrs: PropTypes.shape({}),
  innerBlocks: PropTypes.array
};
export {
  BlockApexFields as default
};
